import * as _ from 'lodash';
import * as utility from '../misc/utility';
import * as EnumValues from '../misc/EnumValues';
import { BaseObject } from './BaseObject';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
 */

export class Organization extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);

            this.Urls = this.Urls || [];
            while (this.Urls.length < 3) {
                this.Urls.push({});
            }
        }
    }

    /**
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        this.OrganizationType = ctx.getOrganizationType(this.OrganizationTypeId);
        this.WageGroup = ctx.getWageGroup(this.WageGroupId);
        this.WageCalculation = ctx.getWageCalculation(this.WageCalculationId);
        this.MandatePeriods = ctx.getMandatePeriod(this.MandatePeriodIds);
        this.PrimaryCertifier = ctx.getPerson(this.PrimaryCertifierId);
        this.SecondaryCertifier = ctx.getPerson(this.SecondaryCertifierId);
        if (_.isArray(this.MandatePeriods)) {
            this.MandatePeriods.sort(function (a, b) {
                return b.Start.getTime() - a.Start.getTime();
            });
        }
    }

    getCurrentMandate() {
        if (!_.isArray(this.MandatePeriods)) return null;
        if (this.MandatePeriods.length === 0) return null;

        var now = new Date();
        return this.MandatePeriods.find(function (x) {
            if (utility.compareCalendarDate(x.Start, now) > 0)
                return false;

            if (x.End == null)
                return true;

            if (utility.compareCalendarDate(now, x.End) > 0)
                return false;

            return true;
        });
    }

    getLastMandate() {
        if (!_.isArray(this.MandatePeriods)) return null;
        if (this.MandatePeriods.length === 0) return null;

        return this.MandatePeriods[0];
    }

    getCurrentOrLastMandate() {
        if (!_.isArray(this.MandatePeriods)) return null;
        if (this.MandatePeriods.length === 0) return null;

        let current = this.getCurrentMandate();
        return current != null ? current : this.MandatePeriods[0];
    }

    toJSON() {
        var ret = super.toJSON();

        ret.OrganizationTypeId = BaseObject.withRelated(ret, "OrganizationType");
        ret.WageGroupId = BaseObject.withRelated(ret, "WageGroup");
        ret.MandatePeriodIds = BaseObject.withRelated(ret, "MandatePeriods");
        ret.WageCalculationId = BaseObject.withRelated(ret, "WageCalculation");
        ret.PrimaryCertifierId = BaseObject.withRelated(ret, "PrimaryCertifier");
        ret.SecondaryCertifierId = BaseObject.withRelated(ret, "SecondaryCertifier");

        ret.MainAddress = utility.addressToJson(ret.MainAddress, EnumValues.AddressType.Home);
        ret.VisitationAddress = utility.addressToJson(ret.VisitationAddress, EnumValues.AddressType.Visitation);
        ret.Email = utility.emailToJson(ret.Email, EnumValues.EmailType.Public);
        ret.Urls = _.chain(ret.Urls)
            .reject(_.isNil)
            .map(x => utility.urlToJson(x, EnumValues.UrlType.Documents))
            .value();

        return ret;
    }

    clone() {
        var src = _.clone(this);
        src.OrganizationType = null;
        src.WageGroup = null;
        src.MandatePeriods = null;
        src.WageCalculation = null;

        var ret = _.cloneDeep(src);
        ret.OrganizationType = this.OrganizationType;
        ret.WageGroup = this.WageGroup;
        ret.MandatePeriods = _.clone(this.MandatePeriods);
        ret.WageCalculation = this.WageCalculation;

        return ret;
    }

    effectiveSortingCode() {
        // Add 'z' in case the name start with numbers
        return this.Active ? this.SortingCode : "z" + this.Name;
    }
}
